import TranslationsEN from '../../translations/en.json';
import TranslationsFR from '../../translations/fr.json';

const getLocalParams = (language) => ({
  lang: language,
  i18n: language === 'en' ? TranslationsEN : TranslationsFR,
});

export default getLocalParams;
